import React from "react";
import ArticleBackground from "../../background.js";
import ArticleBlock from "../../block.js";
import {HasWysiwygContent} from "Functions/index.js";

class ArticleBlockLinkColumns extends ArticleBlock
{
    constructor(props)
    {
        super(props);
        this.Fields =
        {
            title:
            {
                default: "Title",
                label: "Title",
                type: "textarea"   
            },
            layout:
            {
                default: "fourColumns",
                label: "Layout",
                options:
                {
                    twoColumns: "Two Columns",
                    threeColumns: "Three Columns",
                    fourColumns: "Four Columns"
                },
                type: "select"
            },
            columns:
            {
                addLabel: "Add column",
                copy: true,
                fields:
                {
                    title:
                    {
                        label: "Title",
                        type: "textarea"
                    },
                    content:
                    {
                        label: "Content",
                        type: "wysiwyg"   
                    },
                    links:
                    {
                        addLabel: "Add link",
                        copy: true,
                        fields:
                        {
                            label:
                            {
                                label: "Title"
                            },
                            url:
                            {
                                label: "URL",
                                type: "url",
                                default: "https://"

                            },
                            urlBlank:
                            {
                                label: "Open in a new tab",
                                type: "checkbox",
                                default: true
                            }
                        },
                        itemName: "Link",
                        label: "Links",
                        nameKey: "label",
                        type: "repeater"
                    },
                    after:
                    {
                        label: "Content After",
                        type: "wysiwyg"   
                    }
                },
                itemName: "Column",
                label: "Columns",
                nameKey: "title",
                type: "repeater"
            },
            alignTitle:
            {
                default: "center",
                label: "Title alignment",
                options: {
                    left: "Left",
                    center: "Center",
                    right: "Right"
                },
                type: "select"
            },
            backgroundImage:
            {
                label: "Background Image",
                type: "image"
            },
            backgroundOverlay:
            {
                default: false,
                displayIf: ["backgroundImage", "!==", "empty"],
                label: "Background Overlay",
                type: "checkbox"
            },
            itemBackgroundColor:
            {
                gradient: true,
                label: "Items Background Color",
                type: "color",
                default: "transparent"
            },
            itemBackgroundImage:
            {
                label: "Items Background Image",
                type: "image"
            },
            itemBackgroundOverlay:
            {
                default: true,
                displayIf: ["itemBackgroundImage", "!==", "empty"],
                label: "Items Background Overlay",
                type: "checkbox"
            }
        };
        this.MinWidthContent = 800;
        this.MinWidthItem = 220;
        this.state = {
            columns: 0,
            layout: "horizontal"
        };
    }

    componentDidMount()
    {
        super.componentDidMount();
        window.addEventListener("resize", this.OnResize);
        this.OnResize();
    }

    componentWillUnmount()
    {
        super.componentWillUnmount();
        window.removeEventListener("resize", this.OnResize);
    }

    OnResize = () =>
    {
        if (!this.Container || !this.Content)
        {
            return;
        }
        const {columns: currentColumns} = this.state;
        const {layout = "twoColumns"} = this.props.content || {};
        const ColumnWidth = this.Container.offsetWidth / this.MinWidthItem;
        let MaxColumns = 2;
        switch (layout)
        {
            case "fourColumns":
                MaxColumns = 4;
                break;
            case "threeColumns":
                MaxColumns = 3;
                break;
            default:
        }
        const SetColumns = Math.max(1, Math.min(MaxColumns, Math.floor(ColumnWidth)));
        if (SetColumns === currentColumns)
        {
            return;
        }
        this.setState({columns: SetColumns});
    }

    render()
    {
        const {
            attributes, 
            content,
            disabled,
            editable,
            id,
            images,
            onImageUrl,
            style
        } = this.props;
        const {
            alignTitle = "center",
            backgroundImage,
            backgroundOverlay,
            columns = [],
            layout: defaultLayout,
            title = ""
        } = content || {};
        const {
            columns: numColumns
        } = this.state;
        const CA = ["cb", `cb-${id}`, "lnc"];
        if (numColumns > 0)
        {
            CA.push(`_layout_${numColumns}_col`);
        }
        if (editable)
        {
            CA.push("_ce");
        }
        switch (alignTitle)
        {
            case "left":
                CA.push("_al");
                break;
            case "right":
                CA.push("_ar");
                break;
            default:
                CA.push("_ac");
        }
        return (
            <>
                {this.Appearance()}
                <ArticleBackground
                    attributes={attributes}
                    className={CA.join(" ")}
                    disabled={disabled}
                    editable={editable}
                    id="backgroundImage"
                    imageId={backgroundImage}
                    onEdit={this.OnEditableChange}
                    onUrl={onImageUrl}
                    overlay={backgroundOverlay}
                    srcref={images}
                    style={style}
                >
                    <div className="cb-cn" ref={content => this.Content = content}>
                        {title && (
                            <div className="lnc-tp">
                                {this.EditableText(title, "h2", "title", "lnc-t")}
                            </div>
                        )}
                        <div className="lnc-cn" ref={container => this.Container = container} data-layout={defaultLayout}>
                            {columns.map(({after: htmlAfter, content: html, links = [], title: columnTitle}, columnIndex) => (
                                <div className="lnc-cl" key={columnIndex}>
                                    {columnTitle && this.EditableText(columnTitle, "h3", ["columns", columnIndex, "title"], "lnc-cl-t")}
                                    {HasWysiwygContent(html) && this.EditableContent(html, ["columns", columnIndex, "content"], "lnc-cl-ht-before")}
                                    {links && links.length > 0 && (
                                        <div className="lnc-lns">
                                            {links.map(({label, url, urlBlank}, linkIndex) => (
                                                <div key={linkIndex}>
                                                    {this.EditableLink(label, url, ["columns", columnIndex, "links", linkIndex, "label"], "lnc-ln cb-i", urlBlank ? "_blank" : "_top")}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {HasWysiwygContent(htmlAfter) && this.EditableContent(htmlAfter, ["columns", columnIndex, "after"], "lnc-cl-ht-after")}
                                </div>
                            ))}
                        </div>
                    </div>
                </ArticleBackground>
            </>
        );
    }
}

export default ArticleBlockLinkColumns;